import axios, {AxiosError} from 'axios';
import {useMutation, UseMutationOptions} from '@tanstack/react-query';
import {BucketCompanyCode} from '../../../models/config/BucketCompanyCode';
import {ResponseError} from '../../../models/common/Response';

export function useAddBucketCompanyCodeMapping(
    options?: UseMutationOptions<
        BucketCompanyCode,
        AxiosError<ResponseError>,
        BucketCompanyCode
    >
) {
    return useMutation({
        mutationFn: (request) => {
            const accessToken = localStorage.getItem('LG_APPLICATION');
            return axios.post('/v1/configuration/lis/bucket-company-code-mapping', request, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
        },
        ...options,
    });
}